import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FilterService } from '../../generic/service/filter.service';
import { UserService } from '../../generic/service/user.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { OrderTabsComponent } from '../../generic/component/order/ordertabs.component';

@Component({
    selector: 'navbar-tabs',
    styleUrls: ['./navbar.tabs.component.scss'],
    templateUrl: 'navbar.tabs.component.html',
    standalone: true,
    imports: [
        OrderTabsComponent,
        NgClass,
        RouterLink,
        FormsModule,
    ],
})
export class NavbarTabsComponent {
    constructor(
        private router: Router,
        private userService: UserService,
        private filterService: FilterService,
    ) {}

    allowClaims(): boolean {
        return this.userService.getUser().allowClaims;
    }

    /**
     * Check whether the webshop set of tabs needs to be shown.
     *
     * @returns {boolean}
     */
    showWebshopTabs(): boolean {
        return !this.checkActive('my');
    }

    onChangeOrderEvent() {
        this.router.navigateByUrl('/products');
    }

    /**
     * Determine if the 'my noviflora' tab set needs to be shown
     * @returns {boolean}
     */
    showMyTabs(): boolean {
        return this.checkActive('my');
    }

    isOnPendingOrders(): boolean {
        return this.checkActive('pending');
    }

    isOnPricelists(): boolean {
        return this.checkActive('pricelists');
    }

    isOnOrderHistory(): boolean {
        return this.checkActive('history');
    }

    isOnFavorites(): boolean {
        return this.checkActive('favorites');
    }

    isOnClaims(): boolean {
        return this.checkActive('claims');
    }

    logout() {
        // Reset filter history view
        this.filterService.resetHistoryView();
        // Reset user based values
        this.userService.logout();

        // Return false to prevent the default link browser action.
        // The userService.logout() method will trigger the redirect.
        return false;
    }

    /**
     * Navigate method for responsive mode select
     *
     * @param $event
     */
    navigate($event) {
        const navigateTo = $event.target.value;

        if (navigateTo) {
            // Make sure to logout
            if (navigateTo === '/login') {
                this.logout();
            }
            this.router.navigate([navigateTo]);
        }
    }

    /**
     * checks if the given index is part of the url
     *
     * @param index
     * @returns {boolean}
     */
    checkActive(index: string): boolean {
        return this.router.url.indexOf(index) >= 0;
    }
}
